export default __webpack_public_path__ + "static/media/54278854_2001027003348352_16178587753250816_o.8832589e.jpg";